import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InstallAppBannerForDesktop } from '@snapask/common-components';

import useGetCurrentDevice from 'hooks/useGetCurrentDevice';
import { INSTALL_APP_IS_CLOSED } from 'constants/InstallApp';

function InstallAppForDesktopHandler() {
  const { t } = useTranslation(['app']);
  const { isPC, isTablet } = useGetCurrentDevice();
  const [isShow, setIsShow] = useState(false);

  const closeInstall = () => {
    setIsShow(false);
    window.sessionStorage.setItem(INSTALL_APP_IS_CLOSED, true);
  };

  const inactive = useMemo(() => {
    const isTargetDevice = isPC && !isTablet;

    return !(isTargetDevice && isShow);
  }, [isTablet, isPC, isShow]);

  useEffect(() => {
    const isClosed = window.sessionStorage.getItem(INSTALL_APP_IS_CLOSED);

    if (!isClosed) {
      setIsShow(true);
    }
  }, []);

  return (
    <InstallAppBannerForDesktop
      title={t('desktop.title')}
      subtitle={t('desktop.description')}
      inactive={inactive}
      onClose={closeInstall}
    />
  );
}

export default InstallAppForDesktopHandler;
